// /oauth/authorize checks the session itself, so it can send the user to /login and back.
// /cadastro/<token> is the client registration a client fills in through the link the office sends.
const PUBLIC_PATHS = ['/login', '/setup-password', '/oauth/authorize', '/.well-known', '/cadastro']

export function isPublicPath(pathname: string): boolean {
  if (pathname.startsWith('/api/auth')) return true
  return PUBLIC_PATHS.some((p) => pathname === p || pathname.startsWith(`${p}/`))
}

/** The `next` target after login: only a same-origin path, never `//host` or `/\host`. */
export function safeNextPath(next: string | null | undefined): string | null {
  if (!next || !next.startsWith('/') || next.startsWith('//') || next.startsWith('/\\')) return null
  if (/[\u0000-\u001f\\]/.test(next)) return null
  return next
}
